import appColors from 'utils/appColors';
import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
  pageWrap: {
    width: '100%',
    maxWidth: '100%',
  },
  headerCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E6E8EB',
    borderRadius: 16,
    padding: '16px 20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    marginBottom: 16,
  },
  pageSubtitle: {
    fontFamily: 'Poppins',
    fontSize: 13,
    color: '#667085',
    marginTop: 4,
    marginBottom: 12,
    lineHeight: 1.45,
  },
  tabsRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 16,
    borderBottom: 'none',
    '& .MuiTabs-root': {
      minHeight: 44,
    },
  },
  filtersRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    width: '100%',
  },
  searchFieldWrap: {
    flex: '1 1 280px',
    minWidth: 0,
    maxWidth: 720,
  },
  scheduleChip: {
    fontFamily: 'Poppins',
    fontSize: 12,
    fontWeight: 500,
    height: 26,
  },
  expandPaper: {
    backgroundColor: '#F7F9FC',
    borderRadius: 12,
    border: '1px solid #E6E8EB',
    overflow: 'hidden',
    marginTop: 8,
  },
  weekHeaderRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginLeft: 0,
    marginTop: 16,
    marginBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    gap: 8,
  },
  weekDayLabel: {
    color: '#505255',
    fontSize: 13,
    fontWeight: 600,
    minWidth: 72,
    marginRight: 24,
    fontFamily: 'Poppins',
  },
  fullScaleLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 16,
    marginRight: 16,
    marginTop: 8,
  },
  fullScaleLinkText: {
    fontSize: 14,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: appColors.PRIMARY_COLOR,
    fontWeight: 500,
    fontFamily: 'Poppins',
    '&:hover': {
      color: appColors.SECUNDARY_COLOR,
    },
  },
  loadingExpand: {
    textAlign: 'center',
    padding: '24px 16px',
  },
  root: {
    minHeight: '100vh',
    backgroundColor: appColors.BACKGROUND_COLOR,
    marginLeft: 24,
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: 40,
  },
  tableRow: {
    backgroundColor: 'transparent',
    width: '100%',
  },
  tableScales: {
    padding: '8px 20px',
    backgroundColor: 'white',
    width: 1528,
    height: 56,
    marginTop: 8,
    marginRight: 90,
    borderRadius: 4,
    color: '#444',
    alignItems: 'center',
  },
  rootFullScales: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 24,
    marginRight: 20,
    textTransform: 'none',
  },
  textRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 151,
    marginTop: 32,
    marginBottom: 16,
  },
  textWeek: {
    color: '#505255',
    height: '16px',
    width: '96px',
    fontSize: '16px',
    marginRight: 96,
  },
  statusView: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 320,
    color: '#ccc',
  },
  statusText: {
    fontSize: 14,
    color: '#003366',
  },

  rowButton: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  textTable: {
    fontSize: '16px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#003366',
  },
  specialty: {
    fontSize: '16px',
    fontStyle: 'normal',
    height: '24px',
    width: '232px',
    color: '#A2A5A8',
    marginRight: 24,
  },
  headerSearch: {
    backgroundColor: 'white',
    borderRadius: 24,
    border: '1px solid #e9e9e9',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    width: 776,
    height: 48,
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  searchIcon: {
    margin: '0 12px',
    color: '#003366',
    fontSize: 26,
  },
  searchIconClose: {
    margin: '0 12px',
    color: '#A2A5A8',
    fontSize: 24,
  },
  closeIcon: {
    margin: '0 12px',
    color: '#A2A5A8',
    fontSize: 25,
  },

  inputSearch: {
    flex: 1,
    padding: 5,
  },
  table: {
    marginBottom: 18,
    marginTop: 50,
    display: 'flex',
    flexDirection: 'row',
  },
  column: {
    marginRight: 20,
    width: 30,
    color: '#A2A5A8',
  },
  name: {
    height: '24px',
    width: '232px',
    marginLeft: 50,
    marginRight: 33,
  },
  registerButton: {
    height: 40,
    minWidth: 160,
    paddingLeft: 16,
    paddingRight: 16,
    borderRadius: 10,
    background: appColors.SECUNDARY_COLOR,
    textTransform: 'none',
    boxShadow: 'none',
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 500,
    color: '#FFFFFF',
    '&:hover': {
      background: '#0a3458',
      boxShadow: 'none',
      color: '#FFFFFF',
    },
  },
  rowButtons: {
    display: 'flex',
    marginRight: 80,
  },
  tableAddScales: {
    padding: '16px 20px',
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: '#C9D2DE',
    width: '100%',
    maxWidth: '100%',
    minHeight: 72,
    borderRadius: 10,
    marginTop: 12,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      borderColor: appColors.PRIMARY_COLOR,
      backgroundColor: '#FAFBFC',
    },
  },
  textAddTable: {
    fontSize: 14,
    fontWeight: 500,
    marginTop: 0,
    marginLeft: 8,
    color: appColors.THIRD_COLOR,
    fontFamily: 'Poppins',
  },
  iconAdd: {
    fontSize: 22,
    color: appColors.PRIMARY_COLOR,
  },
  inputWidth: {
    width: '100%',
  },
  container_minimizable: {
    overflowX: 'scroll',
    '@media (min-width: 1921px)': {
      maxWidth: '80vw',
    },
    '@media (max-width: 1920px)': {
      maxWidth: '80vw',
    },
    '@media (max-width: 1660px)': {
      maxWidth: '75vw',
    },
    '@media (max-width: 1600px)': {
      maxWidth: '75vw',
    },
    '@media (max-width: 1440px)': {
      maxWidth: '74vw',
    },
    '@media (max-width: 1400px)': {
      maxWidth: '72vw',
    },
    '@media (max-width: 1360px)': {
      maxWidth: '73vw',
    },
    '@media (max-width: 1024px)': {
      maxWidth: '65vw',
    },
  },
  container_minimizableClose: {
    overflowX: 'scroll',
    '@media (min-width: 1921px)': {
      maxWidth: '100vw',
    },
    '@media (max-width: 1920px)': {
      maxWidth: '100vw',
    },
    '@media (max-width: 1660px)': {
      maxWidth: '100vw',
    },
    '@media (max-width: 1600px)': {
      maxWidth: '100vw',
    },
    '@media (max-width: 1440px)': {
      maxWidth: '88vw',
    },
    '@media (max-width: 1400px)': {
      maxWidth: '90vw',
    },
    '@media (max-width: 1360px)': {
      maxWidth: '90vw',
    },
    '@media (max-width: 1024px)': {
      maxWidth: '80vw',
    },
  },
}));

export const DefaultContainer = styled.div`
  padding-top: 4%;
  text-align: flex-start;
  margin-left: 14%;
  @media (max-width: 1920px) {
    padding-top: 4%;
    margin-left: 14%;
  }
  @media (max-width: 1440px) {
    padding-top: 5%;
    margin-left: 18%;
  }
  @media (max-width: 1366px) {
    padding-top: 5%;
    margin-left: 18%;
  }
  @media (max-width: 1024px) {
    padding-top: 7%;
    margin-left: 25%;
  }
  @media (max-width: 768px) {
    padding-top: 7%;
    margin-left: 33%;
  }
`;

export const ContainerTable = styled.div`
  @media (max-width: 1920px) {
  }
  @media (max-width: 1440px) {
  }
  @media (max-width: 1366px) {
  }
  @media (max-width: 1024px) {
  }
  @media (max-width: 768px) {
  }
`;

export const TableControl = styled.div`
  margin-top: 8px;
`;

export const ContainerButton = styled.div`
  width: 208px;
  @media (max-width: 1920px) {
    width: 390px;
    margin-left: 50px;
  }
  @media (max-width: 1440px) {
    width: 300px;
  }
  @media (max-width: 1366px) {
    width: 310px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: #f7f9fc;
  border-radius: 12px;
  border: 1px solid #e6e8eb;
  flex: 1 1 280px;
  min-width: 0;
  max-width: 720px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  &:focus-within {
    border-color: #003366;
    box-shadow: 0 0 0 1px rgba(0, 51, 102, 0.12);
  }
  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;
